import tippy from "tippy.js";
import Swiper from "swiper/bundle";
import { Loader } from "@googlemaps/js-api-loader";
import { GridAlgorithm, MarkerClusterer } from "@googlemaps/markerclusterer";
import LazyLoad from "vanilla-lazyload";
import lightbox from "../modules/lightbox";
import Common from "../modules/common";
import GoogleMap from "../utils/map";
import "../plugins/turn";
import "../plugins/zoom";

function HTMLMarker(pos, count) {
  this.count = count;
  this.pos = pos;
}

const templateHome = {
  init: function () {
    templateHome.technologies.init();
    templateHome.video();
    templateHome.benefits();
    templateHome.magazine();
    if ($(".google__map").length) {
      templateHome.map.init();
    }
    templateHome.events();
  },

  events: function () {
    var interval = setInterval(function () {
      if ($(".hero-bg__img").hasClass("loaded")) {
        $("body").addClass("home-ready");
        clearInterval(interval);
      }
    }, 50);
  },

  technologies: {
    tooltips: [],

    init: function () {
      this.events();
      this.dropdowns();
      this.tooltip();
      this.slider();
    },

    events: function () {
      lightbox.single.init();
      $(".tech-display:not(.tech-display--active) .tech-image__img").each(
        function () {
          $(this)
            .attr("src", $(this).data("src"))
            .removeClass("lazy")
            .removeAttr("data-src");
        }
      );
      $("body").on("click", ".tech-tippy__more button", function (ev) {
        ev.preventDefault();
        var btn = $(this);
        if (btn.data("id")) {
          lightbox.single.open(btn.data("id"));
        }
      });
    },

    dropdowns: function () {
      var timeout;
      // Dropdowns.
      $(".tech-item__btn").on("click", function (e) {
        e.preventDefault();
        clearTimeout(timeout);

        var btn = $(this);
        // Close siblings.
        var siblings = btn.parent().siblings();
        siblings
          .children(".tech-item__btn")
          .removeClass("tech-item__btn--active");
        siblings.children(".tech-sub-items").slideUp(250);
        // show
        timeout = setTimeout(function () {
          btn.addClass("tech-item__btn--active");
          btn.next().slideDown(250);
        }, 250);

        // image.
        templateHome.technologies.display(btn.data("id"));
      });
    },

    display: function (id) {
      $(".tech-display.tech-display--active").removeClass(
        "tech-display--active"
      );

      var display = $('.tech-display[data-id="' + id + '"]');
      display.addClass("tech-display--active");
    },

    tooltip: function () {
      $(".tech-hotspot").each(function () {
        var hotspot = $(this);
        var pin = hotspot.children(".tech-hotspot__pin");
        var tooltip = hotspot.children(".tech-hotspot__tooltip");

        $(this).hover(
          function () {
            $(this).addClass("hover");
            if ($(window).width() < 901) {
              $(
                '.tech-sub-btn[data-item="' +
                  $(".tech-hotspot__pin", this).data("id") +
                  '"]'
              ).click();
              var item = $(
                '.tech-sub-btn[data-item="' +
                  $(".tech-hotspot__pin", this).data("id") +
                  '"]'
              ).closest(".tech-sub-item");
              var to = item.offset().top - $(".header").height();
              if (item.prevAll(".active").length) {
                to -= item
                  .prevAll(".active")
                  .find(".tech-hotspot__tooltip")
                  .outerHeight(true);
              }
              $("html, body").animate(
                {
                  scrollTop: to,
                },
                400
              );
            }
          },
          function () {
            $(this).removeClass("hover");
          }
        );

        var instance = tippy(pin[0], {
          theme: "tech",
          arrow: true,
          content: tooltip.html(),
          allowHTML: true,
          placement: "left",
          interactive: true,
          interactiveBorder: 0,
          onMount: function () {
            Common.lazyLoadInstance.update();
          },
        });
        $('.tech-sub-btn[data-item="' + pin.data("id") + '"]').on(
          "click",
          function () {
            instance.show();
            $(".tech-hotspot").removeClass("hover");
            hotspot.addClass("hover");
          }
        );

        $('.tech-sub-btn[data-item="' + pin.data("id") + '"]')
          .closest(".tech-sub-item")
          .append(tooltip);

        Common.lazyLoadInstance.update();

        $('.tech-sub-btn[data-item="' + pin.data("id") + '"]').on(
          "click",
          function () {
            var that = $(this);
            if (
              $(".tech-sub-item.active .tech-hotspot__tooltip").length &&
              !$(".tech-sub-item.active").is(that.closest(".tech-sub-item"))
            ) {
              $(".tech-sub-item.active .tech-hotspot__tooltip").slideUp(
                200,
                function () {
                  $(".tech-sub-item.active").removeClass("active");
                  that
                    .closest(".tech-sub-item")
                    .addClass("active")
                    .find(".tech-hotspot__tooltip")
                    .slideDown(200);
                }
              );
            } else if (
              !$(".tech-sub-item.active").is(that.closest(".tech-sub-item"))
            ) {
              $(".tech-sub-item.active").removeClass("active");
              that
                .closest(".tech-sub-item")
                .addClass("active")
                .find(".tech-hotspot__tooltip")
                .slideDown(200);
            }
          }
        );
      });
      $(".techs").on("click", ".tech-hotspot__close", function () {
        $(this)
          .closest(".tech-hotspot__tooltip")
          .slideUp(200, function () {
            $(this).closest(".tech-sub-item").removeClass("active");
          });
      });
    },
    slider: function () {
      var slider_dom = $(".magazine__mobile__slider");
      if (slider_dom.length) {
        var nav_prev = slider_dom.find(".swiper-button-prev")[0];
        var nav_next = slider_dom.find(".swiper-button-next")[0];
        var testi_slider = new Swiper(slider_dom[0], {
          loop: false,
          slidesToShow: 1,
          lazy: {
            loadPrevNext: true,
            loadPrevNextAmount: 2,
          },
          navigation: {
            prevEl: nav_prev,
            nextEl: nav_next,
          },
        });
      }
    },
  },

  video: function () {
    $(".video__play").on("click", function () {
      $(this).fadeOut(250);
      var video_dom = $(".video__content");

      new LazyLoad({
        elements_selector: ".video__content",
      });

      setTimeout(function () {
        video_dom.addClass("video__content--active");
        video_dom[0].play();
      }, 250);
    });
  },

  benefits: function () {
    $(".benefit__desc").each(function () {
      var that = $(this);
      $(".benefit__desc__long", that).css({
        minHeight: $(".benefit__desc__short", that).outerHeight(true),
        height: that.hasClass("active")
          ? $(".benefit__desc__long__inner", that).outerHeight(true)
          : $(".benefit__desc__short", that).outerHeight(true),
      });
      that.addClass("ready");
      $(window).resize(function () {
        $(".benefit__desc__long", that).css({
          minHeight: $(".benefit__desc__short", that).outerHeight(true),
          height: that.hasClass("active")
            ? $(".benefit__desc__long__inner", that).outerHeight(true)
            : $(".benefit__desc__short", that).outerHeight(true),
        });
      });
      $(".benefit__button", that).click(function () {
        $(this).toggleClass("active");
        that.toggleClass("active");
        $(".benefit__desc__long", that).css({
          height: that.hasClass("active")
            ? $(".benefit__desc__long__inner", that).outerHeight(true)
            : $(".benefit__desc__short", that).outerHeight(true),
        });
      });
    });
  },

  map: {
    lat: 61.217874,
    lng: 19.700035,
    zoom: 4,
    el: $(".google__map"),
    data: window?.homeMapData,

    init: function () {
      const loader = new Loader({
        apiKey: gmap_api_key,
        version: "weekly",
      });

      loader.load().then((google) => {
        templateHome.map.start();
      });
    },

    start() {
      HTMLMarker.prototype = new google.maps.OverlayView();
      HTMLMarker.prototype.onRemove = function () {
        if (
          this.div &&
          this.div.parentNode &&
          this.div.parentNode.removeChild
        ) {
          this.div.parentNode.removeChild(this.div);
        }
      };
      HTMLMarker.prototype.onAdd = function () {
        const _self = this;

        _self.div = document.createElement("div");
        _self.div.className = "cluster-icon";
        _self.div.innerHTML = `<i class="cluster-icon__icon"></i><span>${_self.count}</i>`;
        var panes = _self.getPanes();
        panes.overlayMouseTarget.appendChild(_self.div);

        google.maps.event.addDomListener(_self.div, "click", function () {
          const zoom = _self.map.getZoom() + 1;
          _self.map.setCenter(_self.pos);
          _self.map.setZoom(zoom);
        });
      };

      HTMLMarker.prototype.draw = function () {
        var overlayProjection = this.getProjection();
        var position = overlayProjection.fromLatLngToDivPixel(this.pos);
        this.div.style.left = position.x + "px";
        this.div.style.top = position.y - 35 + "px";
      };

      templateHome.map.render_map();
    },

    render_map: function () {
      var self = this;

      var map_options = {
        zoom: self.zoom,
        center: {
          lat: self.lat,
          lng: self.lng,
        },
        scrollwheel: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP,
        },
        styles: [
          {
            featureType: "all",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.country",
            elementType: "geometry.stroke",
            stylers: [
              { color: "#ffffff" },
              { weight: 3 },
              { visibility: "on" },
            ],
          },
          {
            featureType: "administrative.country",
            elementType: "labels",
            stylers: [{ visibility: "on" }],
          },
          {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [{ color: "#c0c0c0" }],
          },
          {
            featureType: "administrative.country",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.province",
            elementType: "labels",
            stylers: [{ visibility: "on" }],
          },
          {
            featureType: "administrative.province",
            elementType: "labels.text.fill",
            stylers: [{ color: "#c0c0c0" }],
          },
          {
            featureType: "administrative.province",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels",
            stylers: [{ visibility: "on" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text",
            stylers: [{ visibility: "on" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#c0c0c0" }],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.icon",
            stylers: [{ visibility: "on" }, { color: "#f3f3f3" }],
          },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ color: "#f3f3f3" }],
          },
          {
            featureType: "landscape.natural.landcover",
            elementType: "geometry.stroke",
            stylers: [{ color: "#ababab" }, { weight: 5.5 }],
          },
          {
            featureType: "landscape.natural.terrain",
            elementType: "geometry.stroke",
            stylers: [{ color: "#ababab" }],
          },
          {
            featureType: "poi",
            elementType: "all",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "road",
            elementType: "all",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "all",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{ color: "#ffffff" }],
          },
          {
            featureType: "water",
            elementType: "geometry.stroke",
            stylers: [{ color: "#ababab" }, { weight: 5.5 }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }],
          },
        ],
      };

      var map = new google.maps.Map(self.el[0], map_options);
      var markers = [];
      var activeBubble = -1;

      var infoBubble = new google.maps.InfoWindow({
        content:
          '<div><div class="google__content"><div class="marker__pop"><a href="' +
          self.data.more_url +
          '">' +
          self.data.more_title +
          "</div></div></div>",
        arrowSize: 70,
        arrowPosition: 50,
        arrowStyle: 0,
        shadowStyle: 0,
        padding: 0,
        borderRadius: 0,
        borderWidth: 0,
        backgroundClassName: "google__popup",
        backgroundColor: "transparent",
        maxWidth: 240,
        minWidth: 240,
        closeSrc: self.el.data("close"),
      });

      self.data.locations.forEach(function (location) {
        if (location.location) {
          var latlng = location.location.split(",");
          var origLat = parseFloat(latlng[0]);
          var origLng = parseFloat(latlng[1]);
          latlng = new google.maps.LatLng(latlng[0], latlng[1]);

          var locationCount = parseInt(location.count);

          var image = {
            url: "/themes/base/app/img/pin.svg",
            size: new google.maps.Size(28, 42),
            origin: new google.maps.Point(0, -6),
            anchor: new google.maps.Point(14, 36),
          };

          var marker = new google.maps.Marker({
            position: latlng,
            draggable: false,
            map: map,
            label: {
              text: location.count,
              color: "#fff",
              fontFamily: "futura-pt",
              fontSize: "13px",
              fontWeight: "bold",
            },
            icon: image,
          });
          markers.push(marker);
          marker.addListener("click", function () {
            if (activeBubble != -1) activeBubble.close();
            activeBubble = infoBubble;
            infoBubble.open(map, marker);
          });
        }
      });

      GoogleMap.addHiglight(map);

      // Add a marker clusterer to manage the markers.
      new MarkerClusterer({
        map,
        markers,
        renderer: templateHome.map.renderer,
        algorithm: new GridAlgorithm({
          gridSize: 70,
        }),
      });
    },

    renderer: {
      render: function (markerData, stats, map) {
        let count = 0;
        for (let index = 0; index < markerData.markers.length; index++) {
          const element = markerData.markers[index];
          count += element.label.text ? parseInt(element.label.text) : 0;
        }

        const marker = new HTMLMarker(markerData.position, count);
        marker.setMap(map);

        return marker;
      },
    },
  },

  magazine: function () {
    turn.init();
  },
};

const turn = {
  magazine: $(".magazine"),
  book: $(".magazine__book"),

  init: function () {
    this.default();
  },

  default: function () {
    var total_pages = turn.book.find(".flipbook__book__page").length;
    // Turn.js
    turn.book.turn({
      page: 2,
      width: 1136,
      height: 734,
      autoCenter: true,
      acceleration: true,
    });

    // Disable first and last page
    turn.book.bind("turning", function (event, page) {
      setTimeout(function () {
        $(
          '.page-wrapper[page="' +
            (page + 2) +
            '"] .lazy, .page-wrapper[page="' +
            (page + 3) +
            '"] .lazy'
        ).each(function () {
          if ($(this).attr("data-src")) {
            $(this)
              .attr("src", $(this).data("src"))
              .removeClass("lazy")
              .removeAttr("data-src");
          }
        });
      }, 50);
      if (page == 1 || page == total_pages) {
        event.preventDefault();
      }
    });
    turn.book.bind("start", function (event, pageObject) {
      if (pageObject.page == 1 || pageObject.page == total_pages) {
        event.preventDefault();
      }
    });

    // Zoom.js
    turn.magazine.zoom({
      flipbook: turn.book,
      // max: 1.25,
      duration: 250,
    });

    // Binds the double tap event to the zoom function
    turn.magazine.bind("zoom.doubleTap", turn.zoom_to);

    // Calls the resize function when the window changes, useful when viewing on tablet or mobile phones
    $(window)
      .on("resize", function () {
        turn.resize_viewport();
      })
      .bind("orientationchange", function () {
        turn.resize_viewport();
      });

    // Must be called initially to setup the size
    turn.resize_viewport();

    // Prev
    $(".magazine__nav__prev").on("click", function () {
      turn.book.turn("previous");
    });

    // Next
    $(".magazine__nav__next").on("click", function () {
      turn.book.turn("next");
    });
  },

  resize_viewport: function () {
    var width = $(".magazine-wrap").width();
    var height = width / 2;

    turn.magazine.css({
      width: width,
      height: height,
    });

    turn.magazine.zoom("resize");

    turn.book.turn("size", width, height);
  },

  zoom_to: function (event) {
    setTimeout(function () {
      if (turn.magazine.data().regionClicked) {
        turn.magazine.data().regionClicked = false;
      } else {
        if (turn.magazine.zoom("value") == 1) {
          turn.magazine.zoom("zoomIn", event);
        } else {
          turn.magazine.zoom("zoomOut");
        }
      }
    }, 1);
  },
};

export default templateHome;
